import { WContainer } from '@components/atoms'
import { PaginaNode } from '@gql/graphql'
import { mockArray, mockGenericItem, mockHomepage, mockListing } from '@utils/mock'
import {
  BrandsSection,
  CollezioniSection,
  EffettiSection,
  GenericCardSwiper,
  MagazineSection,
  Page,
  Prefooter,
} from 'components/organisms'
import { useFindMenu, useTrans, useTransRoute } from 'hooks'
import styles from './Template404.module.sass'
import { useEffect } from 'react'
import { collezioneToTrack, trackingEcommerceEvent } from '@utils/gtm'

interface Props {
  collezioni?: any[] // CollezioneNode[]
  brands?: any[]
  magazine?: any[]
  effetti?: any[]
  pagina?: PaginaNode
}

const Template404 = (props: Props) => {
  const { pagina = undefined, collezioni = [], brands = [], magazine = [], effetti = [] } = props

  const t = useTrans()
  const tr = useTransRoute()

  // TODO - capire se è lo stesso menu o se è meglio gestirlo con le traduzioni
  const homeMenu = useFindMenu('pagina-homepage')
  const collezioniMenu = useFindMenu('collezioni-slider', homeMenu)
  const brandsMenu = useFindMenu('brands-slider', homeMenu)
  const effettiMenu = useFindMenu('effetti-slider', homeMenu)
  const ispirazioniMenu = useFindMenu('ispirazioni-slider', homeMenu)

  const handleClickTracking = (item, index) => {
    trackingEcommerceEvent('select_item', {
      item_list_id: pagina?.pk || 0,
      item_list_name: '404',
      items: [collezioneToTrack(item, index, { pk: 0, slug: '404' })],
    })
  }

  useEffect(() => {
    trackingEcommerceEvent('view_item_list', {
      item_list_id: pagina?.pk || 0,
      item_list_name: '404',
      items: collezioni.map((p, index) => {
        return collezioneToTrack(p, index, { pk: 0, slug: '404' })
      }),
    })
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <WContainer>
          <div className={styles.content}>
            <h1 className={styles.title}>{t('Ops!')}</h1>
            <h2 className={styles.subtitle}>{t('Non abbiamo trovato la pagina che cercavi.')}</h2>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: t(
                  '<p>Potresti guardare i nostri contenuti più visualizzati.<br />Scopri di seguito.</p>'
                ),
              }}
            />
          </div>
        </WContainer>
        <CollezioniSection
          collezioni={collezioni}
          item={collezioniMenu}
          handleClickTracking={handleClickTracking}
        />
        <MagazineSection item={ispirazioniMenu} magazines={magazine} />
        <EffettiSection effetti={effetti} item={effettiMenu} />
        <BrandsSection item={brandsMenu} brands={brands} />
        <Prefooter />
      </main>
    </Page>
  )
}

export default Template404
